import { CxAlertsService } from './../../../libs/components/cx-alerts/cx-alerts.service';
import { ModalService } from './modal.service';
import { Router } from '@angular/router';
import { Component, OnInit, Input, ElementRef, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() id: string;
  modalType: string;
  private element: any;
  dataOfModal: any;

  constructor(
    private modalService: ModalService,
    private alertService: CxAlertsService,
    private router: Router,
    private el: ElementRef
  ) {
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    if (!this.id) {
      return;
    }
    document.body.appendChild(this.element);
    this.element.addEventListener('click', (el) => {
      if (el.target.className === 'app_modal__container') {
        this.close();
      }
    });
    this.modalService.add(this);
    this.modalService.closeExamModal.subscribe(
      (dataOfModal) => (this.dataOfModal = dataOfModal)
    );
    this.modalService.modalType.subscribe((type) => (this.modalType = type));
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  open(): void {
    this.element.childNodes.forEach((elementChild) => {
      elementChild.style.display = 'block';
    });
  }

  close(): void {
    this.element.childNodes.forEach((elementChild) => {
      elementChild.style.display = 'none';
    });
  }

  secondaryButtonAction(): void {
    this.dataOfModal.functionSecondaryButton(this.modalService);
  }

  primaryButtonAction(): void {
    switch (this.modalType) {
      case 'cerrarExamen': {
        this.dataOfModal.functionPrincipalButton(
          this.modalService,
          this.modalService,
          this.alertService
        );
        break;
      }
      case 'agentesExposicion': {
        this.modalService.close();
        break;
      }
      case 'cancelarExamen': {
        this.dataOfModal.functionPrincipalButton(
          this.router,
          this.alertService,
          this.modalService
        );
      }
    }
  }
}
